import { render, staticRenderFns } from "./SwedbankPaymentCallback.vue?vue&type=template&id=546b98cc&scoped=true"
import script from "./SwedbankPaymentCallback.vue?vue&type=script&lang=ts"
export * from "./SwedbankPaymentCallback.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "546b98cc",
  null
  
)

export default component.exports